export const LOAN_FEE_RATE = 0.025;
export const SCORE_TARGET = 50;

export const round2 = (n) => Math.round(Number(n || 0) * 100) / 100;

export const buildPercentPicks = (band) => {
  if (!band) return [];
  const min = Number(band.min);
  const max = Number(band.max);
  const mid = round2((min + max) / 2);
  return [...new Set([min, mid, max].map(round2))].sort((a, b) => a - b);
};

export const tierLabel = (tier) =>
  tier === "high" ? "Active band" : tier === "low" ? "Standard band" : "—";

/** API copy may say "owner"; UI says "creator". */
export const loanUiCopy = (text) => {
  if (typeof text !== "string") return "";
  return text
    .replace(/bet house owner/gi, "house creator")
    .replace(/house owner/gi, "house creator")
    .replace(/\bthe owner\b/gi, "the creator")
    .replace(/\bowner can\b/gi, "creator can");
};

export const formatRelativeTime = (value) => {
  if (!value) return "";
  const s = (Date.now() - new Date(value).getTime()) / 1000;
  if (s < 45) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 172800) return "yesterday";
  return `${Math.floor(s / 86400)}d ago`;
};

export const formatFutureTime = (value) => {
  if (!value) return "";
  const s = (new Date(value).getTime() - Date.now()) / 1000;
  if (s <= 0) return "soon";
  if (s < 3600) return `in ${Math.floor(s / 60)}m`;
  if (s < 86400) return `in ${Math.floor(s / 3600)}h`;
  return `in ${Math.floor(s / 86400)}d`;
};
